import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import { Grid, Stack } from '@mui/material';

import DomainNameVerification from './DomainNameVerification';
import Header from './Header';
import { useCurrentPlatformId } from './hooks';
import ModelCounts from './ModelCounts';
import PlatformDeletedAlert from './PlatformDeletedAlert';
import VerifiedEmailAddressesSection from './VerifiedEmailAddressesSection';

export default function AdminPlatform() {
  const platformId = useCurrentPlatformId();
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Link href="/admin">Back</Link>
      </Grid>
      <Grid item xs={12}>
        <PlatformDeletedAlert platformId={platformId} />
      </Grid>
      <Grid item xs={12}>
        <Header id={platformId} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Stack direction="column" spacing={3}>
          <VerifiedEmailAddressesSection platformId={platformId} />
          <ModelCounts />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6}>
        <DomainNameVerification platformId={platformId} />
      </Grid>
    </Grid>
  );
}
